import { Button, DatePicker, Flex } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import './CustomDatePicker.css';

const CustomDatePicker = ({
  picker,
  locale,
  defaultValue = [],
  format,
  onChange,
  onRefresh,
  loading,
  buttonText = 'Buscar'
}) => {
  return (
    <div className="customPicker">
      <DatePicker.RangePicker
        picker={picker}
        locale={locale}
        defaultValue={defaultValue}
        format={format}
        onChange={onChange}
      />

      {onRefresh && (
        <Button className="customPicker-reloadBtn" onClick={onRefresh}>
          {buttonText ? (
            <Flex align="center" gap={8}>
              <span>{buttonText}</span>
              <SyncOutlined spin={loading} />
            </Flex>
          ) : (
            <SyncOutlined spin={loading} />
          )}
        </Button>
      )}
    </div>
  );
};

export default CustomDatePicker;
